var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 16L29.14 18.786L40.3 30H16V34H40.3L29.14 45.146L32 48L48 32L32 16Z",
    fill: "#217EE2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32 60C26.4621 60 21.0486 58.3578 16.444 55.2812C11.8395 52.2045 8.25064 47.8315 6.13139 42.7151C4.01213 37.5988 3.45764 31.969 4.53802 26.5375C5.61841 21.106 8.28515 16.1169 12.201 12.201C16.1169 8.28515 21.106 5.61841 26.5375 4.53802C31.969 3.45764 37.5988 4.01213 42.7151 6.13139C47.8315 8.25064 52.2045 11.8395 55.2812 16.444C58.3578 21.0486 60 26.4621 60 32C59.9915 39.4235 57.0388 46.5405 51.7896 51.7896C46.5405 57.0388 39.4235 59.9915 32 60ZM32 8.00001C27.2533 8.00001 22.6131 9.40759 18.6663 12.0447C14.7195 14.6819 11.6434 18.4302 9.8269 22.8156C8.0104 27.201 7.53512 32.0266 8.46117 36.6822C9.38721 41.3377 11.673 45.6141 15.0294 48.9706C18.3859 52.327 22.6623 54.6128 27.3178 55.5389C31.9734 56.4649 36.799 55.9896 41.1844 54.1731C45.5698 52.3566 49.3181 49.2805 51.9553 45.3337C54.5924 41.3869 56 36.7468 56 32C55.9926 25.6371 53.4617 19.5369 48.9624 15.0376C44.4631 10.5384 38.3629 8.00742 32 8.00001Z",
    fill: "#217EE2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrowIcon);
export default __webpack_public_path__ + "static/media/right-arrow-icon.dc2b2ab348a5a417355e22551a7c14af.svg";
export { ForwardRef as ReactComponent };